import { render, staticRenderFns } from "./UserStores.vue?vue&type=template&id=ee5b84e2"
import script from "./UserStores.vue?vue&type=script&lang=js"
export * from "./UserStores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports